import { render, staticRenderFns } from "./CustomerEnquiryDetails.vue?vue&type=template&id=7bbd038b&"
import script from "./CustomerEnquiryDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerEnquiryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QForm,QCardSection,QInput,QField,QCheckbox,QCardActions,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QForm,QCardSection,QInput,QField,QCheckbox,QCardActions,QTable})
